import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FIRST_RESPONSE_SLA, NEXT_RESPONSE_SLA, CLOSE_TICKET_SLA, RESOLVED_IN_SLA_PROPERTY_VALUE, RESOLVED_OUTSIDE_SLA_PROPERTY_VALUE } from 'conversations-internal-schema/sla/constants/enums';
import { getIsSLAResolved } from 'conversations-internal-schema/sla/operators/getIsSLAResolved';
import { getSLAIconColorTokenFromStatus } from 'conversations-internal-schema/sla/operators/getSLAColorFromStatus';
import SLADetailsTime from './SLADetailsTime';
import { SuccessIcon, TimeIcon, PlayerPauseIcon } from 'foundations-assets';
import { Box } from 'foundations-components/transitional/components/Box';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Text } from 'foundations-components/components/Text';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SLACategoryName = ({
  slaCatagory
}) => {
  switch (slaCatagory) {
    case FIRST_RESPONSE_SLA:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.slaTypes.firstReply"
      });
    case CLOSE_TICKET_SLA:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.slaTypes.timeToClose"
      });
    case NEXT_RESPONSE_SLA:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.slaTypes.nextReply"
      });
    default:
      throw new Error(`SLACatagory ${slaCatagory} isn't one of the known types.`);
  }
};
SLACategoryName.displayName = 'SLACategoryName';
const SLADetailsRowIcon = ({
  isPausedSLA,
  slaStatus
}) => {
  const isSLAResolved = getIsSLAResolved(slaStatus);
  // Show the Paused SLA if the SLA is not already resolved.
  const iconColor = isPausedSLA && !isSLAResolved ? 'icon-core-subtle' : getSLAIconColorTokenFromStatus(slaStatus);
  // 1. If the SLA is resolved, we prioritize that state over other icons and show that first
  // 2. Second, if the SLA is paused, we show the pause icon
  // 3. Otherwise, we show the time icon
  const Icon = useMemo(() => {
    if (isSLAResolved) {
      return SuccessIcon;
    } else if (isPausedSLA) {
      return PlayerPauseIcon;
    }
    return TimeIcon;
  }, [isSLAResolved, isPausedSLA]);
  return /*#__PURE__*/_jsx(IconHolder, {
    icon: Icon,
    color: iconColor
  });
};
SLADetailsRowIcon.displayName = 'SLADetailsRowIcon';
const getCompletedMessage = slaStatus => {
  switch (slaStatus) {
    case RESOLVED_IN_SLA_PROPERTY_VALUE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.completed"
      });
    case RESOLVED_OUTSIDE_SLA_PROPERTY_VALUE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.completedLate"
      });
    default:
      throw new Error(`SLAStatus ${slaStatus} isn't one of the known types.`);
  }
};
export const SLADetailsRow = ({
  isPausedSLA,
  slaDetails
}) => {
  const isSLAResolved = getIsSLAResolved(slaDetails.status);

  // If there is no date, don't render the row at all
  if (!slaDetails.dueDate || slaDetails.dueDate === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(TFlex, {
    justify: "between",
    align: "center",
    marginBlockStart: "300",
    children: [/*#__PURE__*/_jsx(Box, {
      shrink: 0,
      inlineSize: "17px",
      children: /*#__PURE__*/_jsx(SLADetailsRowIcon, {
        isPausedSLA: isPausedSLA,
        slaStatus: slaDetails.status
      })
    }), /*#__PURE__*/_jsx(Box, {
      grow: 1,
      paddingInlineStart: "300",
      paddingInlineEnd: "900",
      children: /*#__PURE__*/_jsx(SLACategoryName, {
        slaCatagory: slaDetails.category
      })
    }), /*#__PURE__*/_jsx(Box, {
      shrink: 0,
      children: isSLAResolved ? getCompletedMessage(slaDetails.status) : /*#__PURE__*/_jsx(Text, {
        as: "span",
        color: isPausedSLA ? 'text-core-subtle' : undefined,
        children: /*#__PURE__*/_jsx(SLADetailsTime, {
          dueDate: slaDetails.dueDate,
          isPausedSLA: isPausedSLA
        })
      })
    })]
  });
};
SLADetailsRow.displayName = 'SLADetailsRow';